import React from 'react';
import EmailLayout from '../components/email/EmailLayout';

const Email: React.FC = () => {
  return <EmailLayout />;
};

export default Email; 